<app-loading *ngIf="contentReady"></app-loading>

<section
  class="bb-page pos-ticket-page"
  [class.rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bb-page-shell pos-ticket-shell">

    <!-- Header -->
    <header class="pos-mobile-hero">
      <div class="pos-hero-copy">
        <span class="bb-eyebrow">
          {{ 'businesses' | transloco }}
        </span>

        <h2>
          {{ 'business branches' | transloco }}
        </h2>

        <p>
          {{ 'choose business and manage' | transloco }}
        </p>
      </div>

      <div class="pos-hero-icon">
        <i class="fa-solid fa-store" aria-hidden="true"></i>
      </div>
    </header>

    <!-- Top Actions -->
    <div class="pos-top-actions">
      @if(superAdmin){
      <button
        type="button"
        routerLink="/createpos"
        class="bb-btn bb-btn-primary"
      >
        <i class="fa-solid fa-plus" aria-hidden="true"></i>
        {{ 'Create new business' | transloco }}
      </button>
      }

      @if(isblueboxMain && superAdmin){
      <button
        type="button"
        [routerLink]="isMobile ? '/e-commerce.mobile' : '/e-commerce'"
        class="bb-btn bb-btn-secondary"
      >
        <i class="fa-solid fa-cart-shopping" aria-hidden="true"></i>
        {{ 'e-commerce manager' | transloco }}

        <span class="bb-badge bb-badge-soft-blue">
          {{ 'BlueBox' | transloco }}
        </span>
      </button>
      }
    </div>

    <!-- POS Tickets -->
    <div class="pos-ticket-list" *ngIf="!noData">
      <article
        class="pos-business-ticket"
        *ngFor="let element of allData; trackBy: trackById"
        [class.is-selected]="isActive(element)"
      >

        <!-- Ticket Top -->
        <div class="pos-ticket-top">

          <div class="pos-business-main">
            <div class="pos-business-logo">
              <img
                [src]="element.image_url || '/assets/logo-01.png'"
                [alt]="getPosName(element)"
              />

              @if(isActive(element)){
              <span class="pos-selected-dot" aria-hidden="true">
                <i class="fa-solid fa-check" aria-hidden="true"></i>
              </span>
              }
            </div>

            <div class="pos-business-copy">
              <div class="pos-business-badges">
                <div [ngSwitch]="element.warehouses_type">
                  <span *ngSwitchCase="'0'" class="bb-badge bb-badge-soft-blue">
                    <i [ngClass]="warehouseTypeIcon(element.warehouses_type)" aria-hidden="true"></i>
                    {{ 'company' | transloco }}
                  </span>

                  <span *ngSwitchCase="'1'" class="bb-badge bb-badge-soft-cyan">
                    <i [ngClass]="warehouseTypeIcon(element.warehouses_type)" aria-hidden="true"></i>
                    {{ 'warehouse' | transloco }}
                  </span>

                  <span *ngSwitchCase="'2'" class="bb-badge bb-badge-primary">
                    <i [ngClass]="warehouseTypeIcon(element.warehouses_type)" aria-hidden="true"></i>
                    {{ 'store' | transloco }}
                  </span>

                  <span *ngSwitchCase="'3'" class="bb-badge bb-badge-success">
                    <i [ngClass]="warehouseTypeIcon(element.warehouses_type)" aria-hidden="true"></i>
                    {{ 'clinic' | transloco }}
                  </span>

                  <span *ngSwitchCase="'4'" class="bb-badge bb-badge-warning">
                    <i [ngClass]="warehouseTypeIcon(element.warehouses_type)" aria-hidden="true"></i>
                    {{ 'store and clinic' | transloco }}
                  </span>

                  <span *ngSwitchCase="'5'" class="bb-badge bb-badge-soft-blue">
                    <i [ngClass]="warehouseTypeIcon(element.warehouses_type)" aria-hidden="true"></i>
                    {{ 'shipping' | transloco }}
                  </span>

                  <span *ngSwitchDefault class="bb-badge bb-badge-danger">
                    <i [ngClass]="warehouseTypeIcon(element.warehouses_type)" aria-hidden="true"></i>
                    {{ 'unknown' | transloco }}
                  </span>
                </div>

                @if(isActive(element)){
                <span class="bb-badge bb-badge-success">
                  {{ 'selected' | transloco }}
                </span>
                }
              </div>

              <h3>
                {{ getPosName(element) }}
              </h3>

              <p>
                <i class="fa-solid fa-location-dot" aria-hidden="true"></i>
                <span>{{ displayValue(element.location) }}</span>
              </p>
            </div>
          </div>

          <div class="bb-action-dropdown dropdown pos-ticket-dropdown">
            <button
              class="bb-icon-btn"
              type="button"
              data-bs-toggle="dropdown"
              data-bs-boundary="viewport"
              aria-expanded="false"
              aria-haspopup="true"
              [attr.aria-label]="'Actions' | transloco"
            >
              <i class="fa-solid fa-ellipsis-vertical" aria-hidden="true"></i>
            </button>

            <ul class="bb-dropdown-menu dropdown-menu dropdown-menu-end">

              <li>
                <a
                  class="bb-dropdown-item dropdown-item"
                  (click)="openDetailsPopup(element)"
                >
                  <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
                  {{ 'posdetails' | transloco }}
                </a>
              </li>

              @if(canManageAppointments(element)){
              <li>
                <a
                  class="bb-dropdown-item dropdown-item"
                  (click)="openAppointments(element.id)"
                >
                  <i class="fa-solid fa-calendar-days" aria-hidden="true"></i>
                  {{ 'clinicAppointments.menuAction' | transloco }}
                </a>
              </li>
              }

              @if(isAdmin){
              <li>
                <a
                  class="bb-dropdown-item dropdown-item"
                  (click)="edit(element)"
                >
                  <i class="fa-solid fa-user-pen" aria-hidden="true"></i>
                  {{ 'edit or add users' | transloco }}
                </a>
              </li>
              }

              @if(superAdmin){
              <li>
                <a
                  class="bb-dropdown-item dropdown-item text-danger"
                  (click)="deleteitem(element.id)"
                >
                  <i class="fa-solid fa-trash-can" aria-hidden="true"></i>
                  {{ 'Delete' | transloco }}
                </a>
              </li>
              }

            </ul>
          </div>

        </div>

        <!-- Meta -->
        <div class="pos-ticket-meta">

          <div class="pos-meta-chip">
            <i class="fa-solid fa-calendar" aria-hidden="true"></i>

            <span>
              {{ 'created at pos' | transloco }}
            </span>

            <strong>
              {{ formatDate(element.created_at) }}
            </strong>
          </div>

          <div class="pos-meta-chip">
            <i class="fa-solid fa-layer-group" aria-hidden="true"></i>

            <span>
              {{ 'business type' | transloco }}
            </span>

            <strong>
              {{ warehouseTypeLabel(element.warehouses_type) | transloco }}
            </strong>
          </div>

          @if(superAdmin){
          <div class="pos-meta-chip pos-meta-chip-wide">
            <i class="fa-solid fa-coins" aria-hidden="true"></i>

            <span>
              {{ 'total business' | transloco }}
            </span>

            <strong class="pos-money-value">
              {{ formatMoney(element.total_value) }}

              @if(hasTotalValue(element.total_value)) {
              {{ 'egp' | transloco }}
              }
            </strong>
          </div>
          }

        </div>

        <!-- Actions -->
        @if(!hasSingleWarehouse){
        <div class="pos-ticket-actions">
          <button
            type="button"
            class="bb-btn bb-btn-secondary"
            (click)="showProducts(element.id)"
          >
            <i class="fa-solid fa-boxes-stacked" aria-hidden="true"></i>

            @if(isAdmin){
            {{ 'markas' | transloco }}
            } @else {
            {{ 'show products' | transloco }}
            }
          </button>

          <button
            type="button"
            class="bb-btn bb-btn-primary"
            (click)="createOrder(element.id)"
          >
            <i class="fa-solid fa-cart-plus" aria-hidden="true"></i>
            {{ 'order from this products' | transloco }}
          </button>
        </div>
        }

      </article>
    </div>

    <!-- Loading More -->
    <div class="pos-mobile-loader" *ngIf="isLoadingMore">
      <span aria-hidden="true"></span>
      <strong>{{ 'loading' | transloco }}</strong>
    </div>

    @if(noData && !contentReady){
    <div class="bb-empty-state bb-text-center">
      <app-nodata></app-nodata>
    </div>
    }

  </div>
</section>

<!-- Details Popup -->
<div
  *ngIf="detailsPopup"
  class="bb-modal-backdrop pos-details-backdrop"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
>
  <div
    class="bb-modal-card pos-details-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="pos-details-title"
  >

    <div class="bb-modal-header">
      <h4 id="pos-details-title">
        {{ 'posdetails' | transloco }}
      </h4>

      <button
        type="button"
        class="bb-modal-close"
        (click)="closeDetailsPopup()"
        [attr.aria-label]="'close' | transloco"
      >
        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
      </button>
    </div>

    <div class="pos-details-list" *ngIf="selectedPosDetails">

      <div class="pos-details-row">
        <i class="fa-solid fa-phone" aria-hidden="true"></i>

        <span>
          {{ 'phone' | transloco }}
        </span>

        <a
          [attr.href]="selectedPosDetails.phonenumber ? getPhoneHref(selectedPosDetails.phonenumber) : null"
          [attr.aria-disabled]="!selectedPosDetails.phonenumber ? 'true' : null"
          [attr.tabindex]="!selectedPosDetails.phonenumber ? -1 : null"
        >
          {{ displayValue(selectedPosDetails.phonenumber) }}
        </a>
      </div>

      <div class="pos-details-row">
        <i class="fa-solid fa-phone-volume" aria-hidden="true"></i>

        <span>
          {{ 'Another Phone Number' | transloco }}
        </span>

        <a
          [attr.href]="selectedPosDetails.another_phonenumber ? getPhoneHref(selectedPosDetails.another_phonenumber) : null"
          [attr.aria-disabled]="!selectedPosDetails.another_phonenumber ? 'true' : null"
          [attr.tabindex]="!selectedPosDetails.another_phonenumber ? -1 : null"
        >
          {{ displayValue(selectedPosDetails.another_phonenumber) }}
        </a>
      </div>

      <div class="pos-details-row">
        <i class="fa-solid fa-globe" aria-hidden="true"></i>

        <span>
          {{ 'website_link' | transloco }}
        </span>

        <a
          target="_blank"
          rel="noopener noreferrer"
          [attr.href]="selectedPosDetails.website_link ? getExternalHref(selectedPosDetails.website_link) : null"
          [attr.aria-disabled]="!selectedPosDetails.website_link ? 'true' : null"
          [attr.tabindex]="!selectedPosDetails.website_link ? -1 : null"
        >
          {{ displayValue(selectedPosDetails.website_link) }}
        </a>
      </div>

      <div class="pos-details-row">
        <i class="fa-brands fa-facebook" aria-hidden="true"></i>

        <span>
          {{ 'facebook' | transloco }}
        </span>

        <a
          target="_blank"
          rel="noopener noreferrer"
          [attr.href]="selectedPosDetails.facebook_link ? getExternalHref(selectedPosDetails.facebook_link) : null"
          [attr.aria-disabled]="!selectedPosDetails.facebook_link ? 'true' : null"
          [attr.tabindex]="!selectedPosDetails.facebook_link ? -1 : null"
        >
          {{ displayValue(selectedPosDetails.facebook_link) }}
        </a>
      </div>

      <div class="pos-details-row">
        <i class="fa-brands fa-instagram" aria-hidden="true"></i>

        <span>
          {{ 'instagram' | transloco }}
        </span>

        <a
          target="_blank"
          rel="noopener noreferrer"
          [attr.href]="selectedPosDetails.instagram_link ? getExternalHref(selectedPosDetails.instagram_link) : null"
          [attr.aria-disabled]="!selectedPosDetails.instagram_link ? 'true' : null"
          [attr.tabindex]="!selectedPosDetails.instagram_link ? -1 : null"
        >
          {{ displayValue(selectedPosDetails.instagram_link) }}
        </a>
      </div>

      <div class="pos-details-row">
        <i class="fa-brands fa-tiktok" aria-hidden="true"></i>

        <span>
          {{ 'tiktok' | transloco }}
        </span>

        <a
          target="_blank"
          rel="noopener noreferrer"
          [attr.href]="selectedPosDetails.tiktok_link ? getExternalHref(selectedPosDetails.tiktok_link) : null"
          [attr.aria-disabled]="!selectedPosDetails.tiktok_link ? 'true' : null"
          [attr.tabindex]="!selectedPosDetails.tiktok_link ? -1 : null"
        >
          {{ displayValue(selectedPosDetails.tiktok_link) }}
        </a>
      </div>

    </div>

    <div class="bb-modal-actions">
      <button
        type="button"
        class="bb-btn bb-btn-secondary"
        (click)="closeDetailsPopup()"
      >
        {{ 'close' | transloco }}
      </button>
    </div>

  </div>
</div>
